<template>
  <!--  管理员-人材管理 -->
  <div class="main-css">
    <!--  标题-->
    <div class="title-css">{{ $t("talentManagement")}}</div>
    <div class="main-box">
      <!-- button 部分 -->
      <div class="line-button-box">
        <el-button class="button-css" @click="handleAddClick">{{$t("new")}}</el-button>
        <el-dropdown @command="handleUpdateAppStatus">
          <el-button type="primary" class="button-css">
            {{$t("changeState")}}
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="(item1,index) in applicationStatusData" :key="item1.code" :command="item1">
              {{item1.name}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button class="button-css" @click="handleDeleteClick">{{$t("delete")}}</el-button>
      </div>
      <!--    表格部分-->
      <div class="table">
        <el-table ref="multipleTable" :data="tableData" style="width: 95%;" height="560px" @row-click="rowClick"
          @selection-change="handleSelectionChange" @sort-change="changeTableSort" v-loading="loading">
          <!--------------选择框----------------->
          <el-table-column type="selection" width="45"> </el-table-column>
          <!--------------人材番号----------------->
          <el-table-column prop="number" label="人材番号" width="100" :show-overflow-tooltip="true">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("talentNumber") }}</p>
              <el-input v-model="searchData1" size="mini" placeholder="Search" @input="fuzzyQuery" clearable />
            </template>
            <template slot-scope="scope">
              <span @click="jump(scope.row.resumeId)">{{scope.row.resumeId}}</span>
            </template>
          </el-table-column>
          <!--------------氏名----------------->
          <el-table-column prop="name1" label="氏名" width="120" :show-overflow-tooltip="true">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("name") }}</p>
              <el-input v-model="searchData2" size="mini" placeholder="Search" @input="fuzzyQuery" clearable />
            </template>
            <template slot-scope="scope">
              {{scope.row.name}}
            </template>
          </el-table-column>

          <!--------------性別----------------->
          <el-table-column prop="sex" label="性別" width="120" :show-overflow-tooltip="true">
            <template slot="header">
              <p>{{ $t("sex") }}</p>

              <el-dropdown @command="handleCommandsex">
                <span class="el-dropdown-link">
                  {{ sexName }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="(item,index) in sexData" :key="item.code" :command="item">{{item.name}}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <template slot-scope="scope">
              <span v-if="language==='CN'">
                {{scope.row.sex_dictText}}
              </span>
              <span v-else>
                {{scope.row.jpsex_dictText}}
              </span>
            </template>
          </el-table-column>
          <!--------------フリガナ----------------->
          <el-table-column prop="name2" label="フリガナ" width="150" :show-overflow-tooltip="true">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("Fur") }}</p>
              <el-input v-model="searchData3" size="mini" placeholder="Search" @input="fuzzyQuery" clearable />
            </template>
            <template slot-scope="scope">
              {{scope.row.anonym}}
            </template>
          </el-table-column>
          <!--------------就職担当----------------->
          <el-table-column prop="assume" label="就職担当" width="100" :show-overflow-tooltip="true">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("inauguration") }}</p>
              <el-input v-model="searchData4" size="mini" placeholder="Search" @input="fuzzyQuery" clearable />
            </template>
            <template slot-scope="scope">
              {{scope.row.principal}}
            </template>
          </el-table-column>
          <!--------------所属教育機関----------------->
          <el-table-column prop="education" label="所属教育機関" width="300" :show-overflow-tooltip="true">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("belongsMedical") }}</p>
              <el-input v-model="searchData5" size="mini" placeholder="Search" @input="fuzzyQuery" clearable />
            </template>
            <template slot-scope="scope">
              {{scope.row.educationName}}
            </template>
          </el-table-column>
          <!--------------現住所----------------->
          <el-table-column prop="address" label="現住所" width="280" :show-overflow-tooltip="true">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("currentAddress") }}</p>
              <el-input v-model="searchData6" size="mini" placeholder="Search" @input="fuzzyQuery" clearable />
            </template>
            <template slot-scope="scope">
              {{scope.row.address}}
            </template>
          </el-table-column>
          <!--------------電話番号----------------->
          <el-table-column prop="phone" label="電話番号" width="130" :show-overflow-tooltip="true">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("telephoneNumber") }}</p>
              <el-input v-model="searchData7" size="mini" placeholder="Search" @input="fuzzyQuery" clearable />
            </template>
            <template slot-scope="scope">
              {{scope.row.telephone}}
            </template>
          </el-table-column>
          <!--------------メール----------------->
          <el-table-column prop="mail" label="メール" width="200" :show-overflow-tooltip="true">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("emil") }}</p>
              <el-input v-model="searchData8" size="mini" placeholder="Search" @input="fuzzyQuery" clearable />
            </template>
            <template slot-scope="scope">
              {{scope.row.email}}
            </template>
          </el-table-column>
          <!--------------日本語----------------->
          <el-table-column prop="japanese" label="日本語" width="200">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("japanese") }}</p>
              <el-dropdown @command="handleCommandjapanese">
                <span class="el-dropdown-link">
                  {{ japaneseName }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="(item,index) in japaneseData" :key="item.code" :command="item">{{item.name}}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <template slot-scope="scope">
              <span v-if="language === 'CN'">
                {{ scope.row.japanese_dictText }}
              </span>
              <span v-else>
                {{ scope.row.jpjapanese_dictText }}
              </span>
            </template>
          </el-table-column>
          <!--------------英語----------------->
          <el-table-column prop="english" label="英語" width="130">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("english") }}</p>
              <el-dropdown @command="handleCommandenglish">
                <span class="el-dropdown-link">
                  {{ englishName }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="(item,index) in englishData" :key="item.code" :command="item">{{item.name}}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <template slot-scope="scope">
              <span v-if="language === 'CN'">
                {{ scope.row.english_dictText }}
              </span>
              <span v-else>
                {{ scope.row.jpenglish_dictText }}
              </span>
            </template>
          </el-table-column>
          <!--------------その他----------------->
          <el-table-column prop="other" label="その他" width="130">
            <template slot="header" slot-scope="scope">
              <p class="operate">{{ $t("other") }}</p>
            </template>
            <template slot-scope="scope">
              {{scope.row.other}}
            </template>
          </el-table-column>
          <!--------------資格1----------------->
          <el-table-column prop="qualification1" label="資格1" width="130" :show-overflow-tooltip="true">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("qualification1") }}</p>
              <el-input v-model="searchData9" size="mini" placeholder="Search" @input="fuzzyQuery" clearable />
            </template>
            <template slot-scope="scope">
              <span v-if="scope.row.qualification1 == 1">{{$t("selected")}}</span>
              <span v-else>{{$t("notSelected")}}</span>
            </template>
          </el-table-column>
          <!--------------資格2----------------->
          <el-table-column prop="qualification2" label="資格2" width="130" :show-overflow-tooltip="true">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("qualification2") }}</p>
              <el-input v-model="searchData10" size="mini" placeholder="Search" @input="fuzzyQuery" clearable />
            </template>
            <template slot-scope="scope">
              <span v-if="scope.row.qualification2 == 1">{{$t("selected")}}</span>
              <span v-else>{{$t("notSelected")}}</span>
            </template>
          </el-table-column>
          <!--------------資格3----------------->
          <el-table-column prop="qualification3" label="資格3" width="130" :show-overflow-tooltip="true">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("qualification3") }}</p>
              <el-input v-model="searchData11" size="mini" placeholder="Search" @input="fuzzyQuery" clearable />
            </template>
            <template slot-scope="scope">
              <span v-if="scope.row.qualification3 ==1">{{$t("selected")}}</span>
              <span v-else>{{$t("notSelected")}}</span>
            </template>
          </el-table-column>
<!--          &lt;!&ndash;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;最新修正日付-&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&ndash;&gt;-->
<!--          <el-table-column prop="PR" label="最新修正日付" width="130" sortable :show-overflow-tooltip="true">-->
<!--            <template slot="header" slot-scope="scope">-->
<!--              <p class="operate">{{ $t("lastUpdataDay") }}</p>-->
<!--            </template>-->
<!--            <template slot-scope="scope">-->
<!--              {{scope.row.pr.substring(0,10)}}-->
<!--            </template>-->
<!--          </el-table-column>-->
          <!--------------自己PR----------------->
          <el-table-column prop="PR" label="自己PR" width="130" :show-overflow-tooltip="true">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("selfPR") }}</p>
              <el-input v-model="searchData12" size="mini" placeholder="Search" @input="fuzzyQuery" clearable />
            </template>
            <template slot-scope="scope">
              {{scope.row.pr}}
            </template>
          </el-table-column>
          <!--------------学校----------------->
          <el-table-column prop="school" label="学校" width="150" :show-overflow-tooltip="true">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("school") }}</p>
              <el-input v-model="searchData13" size="mini" placeholder="Search" @input="fuzzyQuery" clearable />
            </template>
            <template slot-scope="scope">
              {{scope.row.school}}
            </template>
          </el-table-column>
          <!--------------専攻----------------->
          <el-table-column prop="professional" label="専攻" :show-overflow-tooltip="true">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("major") }}</p>
              <el-input v-model="searchData14" size="mini" placeholder="Search" @input="fuzzyQuery" clearable />
            </template>
            <template slot-scope="scope">
              {{scope.row.profession}}
            </template>
          </el-table-column>
          <!--------------入学年月----------------->
          <el-table-column prop="schoolDate" label="入学年月" width="120" :show-overflow-tooltip="true">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("dateAdmission") }}</p>
              <el-input v-model="searchData15" size="mini" placeholder="Search" @input="fuzzyQuery" clearable />
            </template>
            <template slot-scope="scope">
              {{scope.row.enrollment.substring(0,10)}}
            </template>
          </el-table-column>
          <!--------------卒業年月----------------->
          <el-table-column prop="graduationDate" label="卒業年月" width="120" :show-overflow-tooltip="true">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("graduationDate") }}</p>
              <el-input v-model="searchData16" size="mini" placeholder="Search" @input="fuzzyQuery" clearable />
            </template>
            <template slot-scope="scope">
              {{scope.row.graduation.substring(0,10)}}
            </template>
          </el-table-column>
          <!--------------勤め先----------------->
          <el-table-column prop="workplace" label="勤め先" width="120" :show-overflow-tooltip="true">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("workPlace") }}</p>
              <el-input v-model="searchData17" size="mini" placeholder="Search" @input="fuzzyQuery" clearable />
            </template>
            <template slot-scope="scope">
              {{scope.row.workPlace}}
            </template>
          </el-table-column>
          <!--------------所属----------------->
          <el-table-column prop="department" label="所属" :show-overflow-tooltip="true">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("belongs") }}</p>
              <el-input v-model="searchData18" size="mini" placeholder="Search" @input="fuzzyQuery" clearable />
            </template>
            <template slot-scope="scope">
              {{scope.row.type}}
            </template>
          </el-table-column>
          <!--------------開始年月----------------->
          <el-table-column prop="startDate" label="開始年月" width="120" :show-overflow-tooltip="true">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("startYear") }}</p>
              <el-input v-model="searchData19" size="mini" placeholder="Search" @input="fuzzyQuery" clearable />
            </template>
            <template slot-scope="scope">
              {{scope.row.startYear.substring(0,10)}}
            </template>
          </el-table-column>
          <!--------------終了年月----------------->
          <el-table-column prop="endDate" label="終了年月" width="120" :show-overflow-tooltip="true">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("endDate") }}</p>
              <el-input v-model="searchData20" size="mini" placeholder="Search" @input="fuzzyQuery" clearable />
            </template>
            <template slot-scope="scope">
              {{scope.row.endYear.substring(0,10)}}
            </template>
          </el-table-column>
          <!--------------希望勤務地----------------->
          <el-table-column prop="hopeWorking" label="希望勤務地" width="120" :show-overflow-tooltip="true">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("preferredWorkplace") }}</p>
              <el-input v-model="searchData21" size="mini" placeholder="Search" @input="fuzzyQuery" clearable />
            </template>
            <template slot-scope="scope">
              {{scope.row.hopeWorkplace}}
            </template>
          </el-table-column>
          <!--------------希望雇用形態1----------------->
          <el-table-column prop="employmentPattern1" label="希望雇用形態1" width="200" :show-overflow-tooltip="true">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("hopeToHireForm1") }}</p>
              <el-input v-model="searchData22" size="mini" placeholder="Search" @input="fuzzyQuery" clearable />
            </template>
            <template slot-scope="scope">
              <span v-if="scope.row.hopeForm1 ==1">{{$t("fullTimeEmployee")}}</span>
              <span v-else>{{$t("notSelected")}}</span>
            </template>
          </el-table-column>
          <!--------------希望雇用形態2----------------->
          <el-table-column prop="employmentPattern2" label="希望雇用形態2" width="200" :show-overflow-tooltip="true">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("hopeToHireForm2") }}</p>
              <el-input v-model="searchData23" size="mini" placeholder="Search" @input="fuzzyQuery" clearable />
            </template>
            <template slot-scope="scope">
              <span v-if="scope.row.hopeForm2 ==1">{{$t("partTimeJob")}}</span>
              <span v-else>{{$t("notSelected")}}</span>
            </template>
          </el-table-column>
          <!--------------希望雇用形態3----------------->
          <el-table-column prop="employmentPattern3" label="希望雇用形態3" width="200" :show-overflow-tooltip="true">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("hopeToHireForm3") }}</p>
              <el-input v-model="searchData24" size="mini" placeholder="Search" @input="fuzzyQuery" clearable />
            </template>
            <template slot-scope="scope">
              <span v-if="scope.row.hopeForm3 == 1">{{$t("specificSkill")}}</span>
              <span v-else>{{$t("notSelected")}}</span>
            </template>
          </el-table-column>
          <!--------------希望雇用形態4----------------->
          <el-table-column prop="employmentPattern4" label="希望雇用形態4" width="200" :show-overflow-tooltip="true">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("status") }}</p>
              <el-input v-model="searchData25" size="mini" placeholder="Search" @input="fuzzyQuery" clearable />
            </template>
            <template slot-scope="scope">
              <span v-if="scope.row.hopeForm4 == 1">{{$t("technicalInternTrainee")}}</span>
              <span v-else>{{$t("notSelected")}}</span>
            </template>
          </el-table-column>
          <!--------------希望給与----------------->
          <el-table-column prop="expectedSalary" label="希望給与" width="120" :show-overflow-tooltip="true">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("expectedSalary") }}</p>
              <el-input v-model="searchData26" size="mini" placeholder="Search" @input="fuzzyQuery" clearable />
            </template>
            <template slot-scope="scope">
              {{scope.row.hopeSalary}}
            </template>
          </el-table-column>
          <!--------------最低額----------------->
          <el-table-column prop="minimum" label="最低額" sortable :show-overflow-tooltip="true">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("minimum") }}</p>
              <el-input v-model="searchData27" size="mini" placeholder="Search" @input="fuzzyQuery" clearable />
            </template>
            <template slot-scope="scope">
              {{scope.row.startSalary}}
            </template>
          </el-table-column>
          <!--------------最高額----------------->
          <el-table-column prop="maximumAmount" label="最高額" sortable :show-overflow-tooltip="true">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("maximumAmount") }}</p>
              <el-input v-model="searchData28" size="mini" placeholder="Search" @input="fuzzyQuery" clearable />
            </template>
            <template slot-scope="scope">
              {{scope.row.endSalary}}
            </template>
          </el-table-column>
          <!--------------他のご要望----------------->
          <el-table-column prop="otherRequests" label="他のご要望" width="150" :show-overflow-tooltip="true">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("status") }}</p>
              <el-input v-model="searchData29" size="mini" placeholder="Search" @input="fuzzyQuery" clearable />
            </template>
            <template slot-scope="scope">
              {{scope.row.otherHope}}
            </template>
          </el-table-column>
          <!--------------登録日付----------------->
          <el-table-column prop="registrationDate" label="登録日付" width="200" sortable :show-overflow-tooltip="true">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("registerDay") }}</p>
              <el-date-picker type="date" v-model="searchData30" placeholder="All" @input="fuzzyQuery">
              </el-date-picker>
            </template>
            <template slot-scope="scope">
              {{scope.row.createTime.substring(0,10)}}
            </template>
          </el-table-column>
          <!--------------最新修正日付----------------->
          <el-table-column prop="lastRevision" label="最新修正日付" width="200" sortable :show-overflow-tooltip="true">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("lastUpdataDay") }}</p>
              <el-date-picker type="date" v-model="searchData31" placeholder="All" @input="fuzzyQuery">
              </el-date-picker>
            </template>
            <template slot-scope="scope">
              {{scope.row.updateTime.substring(0,10)}}
            </template>
          </el-table-column>
          <!--------------観覧数----------------->
          <el-table-column prop="pageView" label="観覧数" sortable :show-overflow-tooltip="true">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("numberOfVisits") }}</p>
              <el-input v-model="searchData32" size="mini" placeholder="Search" @input="fuzzyQuery" clearable />
            </template>
            <template slot-scope="scope">
              {{scope.row.visitedTime}}
            </template>
          </el-table-column>

          <!--------------状態----------------->
          <el-table-column prop="state" label="状態" width="200">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("status") }}</p>
              <el-dropdown @command="handleCommandapplicationStatus">
                <span class="el-dropdown-link">
                  {{ applicationStatusName }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="(item,index) in applicationStatusData" :key="item.code" :command="item">
                    {{item.name}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <template slot-scope="scope">
              <span v-if="language==='CN'">
                {{scope.row.applicationStatus_dictText}}
              </span>
              <span v-else>
                {{scope.row.jpapplicationStatus_dictText}}
              </span>
            </template>
          </el-table-column>

          <!--------------操作----------------->
          <el-table-column label="操作" fixed="right" width="100">
            <template slot="header">
              <p class="operate"> {{ $t("operate") }}
              </p>
            </template>
            <template slot-scope="scope">
              <button class="save-button" @click="handleSaveClick(scope.row.resumeId)">
                {{ $t("toEdit") }}
              </button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- ------------------------状态变更的dialog------------------------ -->
      <div>
        <el-dialog title="状态变更" :visible.sync="dialogIsShow" width="30%">
          <div class="change-name-css" v-if="stateChange[0]">
            氏名:{{ stateChange[0].userName }}
          </div>
          <el-form :model="form" style="margin-left: 100px;">
            <el-form-item label="状态选择">
              <el-select v-model="form.region" placeholder="请选择状态">
                <el-option :label="item.name" :value="item.code" v-for="(item, index) in stateList" :key="index">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">{{ $t("cancel") }}</el-button>
            <el-button type="primary" @click="stateSure">{{ $t("confirm") }}</el-button>
          </div>
        </el-dialog>
      </div>
      <!-- 弹窗详细信息 -->
      <div class="employee-application" v-if="dialogIsShow1">
        <div class="dialog-box">
          <!-- 关闭按钮 -->
          <div class="close-button" @click="dialogClose1">×</div>
          <!-- 显示图片 -->
          <div class="case-img">
            <div class="one-box-left1">
              <img :src="urlImgInfo" alt="" />
            </div>
            <div class="one-box-left2">
              <div class="one-box-left-line1">
                <div class="one-box-left-line-smallleft">
                  <p></p>
                </div>
                <div class="one-box-left-line-smallright">
                  <p>{{ infoList.anonym }}</p>
                </div>
              </div>
              <div class="one-box-left-line2">
                <div class="one-box-left-line-smallleft">
                  <p>{{ $t("name") }}</p>
                </div>
                <div class="one-box-left-line-smallright">
                  <p>{{ infoList.name }}</p>
                </div>
              </div>
              <div class="one-box-left-line3">
                <div class="one-box-left-line-smallleft">
                  <p>{{ $t("sex") }}</p>
                </div>
                <div class="one-box-left-line-smallright">
<!--                  <p>{{ infoList.sex }}</p>-->

                  <span v-if="infoList.sex == '0'">{{"男性"}}</span>
                  <span v-else>{{"女性"}}</span>
                </div>
              </div>
              <div class="one-box-left-line4">
                <div class="one-box-left-line-smallleft">
                  <p>{{ $t("birth") }}</p>
                </div>
                <div class="one-box-left-line-smallright">
                  <p>{{ infoList.birth.split(" ")[0] }}</p>
                </div>
              </div>
            </div>

          </div>
          <!-- 标签部分 -->
          <div class="label">
            <div :class="label1 ? 'label-box' : 'label-box-active'" @click="labelIsShow(1)">日本語上手<span
                @click.stop="labelDel(1)">×</span></div>
            <div :class="label2 ? 'label-box' : 'label-box-active'" @click="labelIsShow(2)">資格あり <span
                @click.stop="labelDel(2)">×</span></div>
            <div :class="label3 ? 'label-box' : 'label-box-active'" @click="labelIsShow(3)">随時面接 <span
                @click.stop="labelDel(3)">×</span></div>
            <div :class="label4 ? 'label-box' : 'label-box-active'" @click="labelIsShow(4)">決心あり <span
                @click.stop="labelDel(4)">×</span></div>
          </div>
          <!-- 第一行 -->
          <div class="inline-box">
            <div class="inline-left">
              <div class="inline-left-title">{{ $t("contactAddress") }}</div>
              <div class="inline-left-title-main">
                {{ $t("currentAddress") }}
              <el-tooltip placement="top" :content="infoList.address">  <div class="inline-left-title-main-right">
                  {{ infoList.address }}
                </div>
              </el-tooltip>
              </div>

              <div class="inline-left-title-main">{{ $t("email") }}
                <el-tooltip placement="top" :content="infoList.email"> 
                <div class="inline-left-title-main-right">
                  {{ infoList.email }}
                </div>
              </el-tooltip>  
              </div>

              <div class="inline-left-title-main">{{ $t("telephoneNumber") }}
                
                <div class="inline-left-title-main-right">
                  {{ infoList.telephone }}
                </div>
              </div>

            </div>
            <div class="inline-right">
              <div class="inline-left-title">{{ $t("education") }}</div>

              <div class="inline-left-title-main">{{ $t("period") }}
                <!-- <el-tooltip placement="top" :content="replaceText(infoList.enrollment) +' '+ replaceText(infoList.graduation) ">   -->
                <div class="inline-left-title-main-right" v-if="infoList.enrollment && infoList.graduation">
                  {{ infoList.enrollment.split(" ")[0] }}  {{ infoList.graduation.split(" ")[0] }}
                </div>
              <!-- </el-tooltip>   -->
              </div>

              <div class="inline-left-title-main">{{ $t("school") }}
                <el-tooltip placement="top" :content="infoList.school"> 
                <div class="inline-left-title-main-right">
                  {{ infoList.school }}
                </div>
              </el-tooltip>  
              </div>

              <div class="inline-left-title-main">{{ $t("major") }}
                <el-tooltip placement="top" :content="infoList.profession"> 
                <div class="inline-left-title-main-right">
                  {{ infoList.profession }}
                </div>
              </el-tooltip>  
              </div>
            </div>
          </div>
          <!-- 第二行 -->
          <div class="inline-box">
            <div class="inline-left">
              <div class="inline-left-title">{{ $t("languageSkills") }}</div>
              <div class="inline-left-title-main">
                {{ $t("japanese") }}
                <div class="inline-left-title-main-right">
                  JLPT {{ infoList.japanese }}
                </div>
              </div>

              <div class="inline-left-title-main">{{ $t("english") }}
                <div class="inline-left-title-main-right">
                  TOEIC {{ infoList.english }}
                </div>
              </div>

              <div class="inline-left-title-main">{{ $t("other") }}
                <el-tooltip placement="top" :content="infoList.other"> 
                <div class="inline-left-title-main-right">
                  {{ infoList.other }}
                </div>
              </el-tooltip>  
              </div>

            </div>
            <div class="inline-right">
              <div class="inline-left-title">{{ $t("workHistory") }}</div>

              <div class="inline-left-title-main">{{ $t("period") }}
                <!-- <el-tooltip placement="top" :content="replaceText(infoList.startYear) +' '+ replaceText(infoList.endYear)">  -->
                <div class="inline-left-title-main-right" v-if="infoList.startYear && infoList.endYear">
                  {{ infoList.startYear.split(" ")[0] }} {{ infoList.endYear.split(" ")[0] }}
                </div>
              <!-- </el-tooltip>   -->
              </div>

              <div class="inline-left-title-main">{{ $t("companyName") }}
                <el-tooltip placement="top" :content="infoList.educationName"> 
                <div class="inline-left-title-main-right">
                  {{ infoList.educationName }}
                </div>
              </el-tooltip> 
              </div>

              <div class="inline-left-title-main">{{ $t("affiliation") }}
                <el-tooltip placement="top" :content="infoList.type"> 
                <div class="inline-left-title-main-right">
                  {{ infoList.type }}
                </div>
              </el-tooltip> 
              </div>
            </div>
          </div>
          <!-- 第三行 -->
          <div class="inline-box">
            <div class="inline-left">
              <div class="inline-left-title">{{ $t("qualification") }}</div>
              <div class="inline-left-title-main">
                <el-tooltip placement="top" :content="infoList.qualification1"> 
                <div class="inline-left-title-main-right">
                  {{ infoList.qualification1 }}
                </div>
              </el-tooltip> 
              </div>
              <div class="inline-left-title-main">
                <el-tooltip placement="top" :content="infoList.qualification2"> 
                <div class="inline-left-title-main-right">
                  {{ infoList.qualification2 }}
                </div>
              </el-tooltip> 
              </div>
              <div class="inline-left-title-main">
                <el-tooltip placement="top" :content="infoList.qualification3"> 
                <div class="inline-left-title-main-right">
                  {{ infoList.qualification3 }}
                </div>
              </el-tooltip> 
              </div>

            </div>
            <div class="inline-right">
              <div class="inline-left-title">{{ $t("request") }}</div>

              <div class="inline-left-title-main">{{ $t("joinCompany") }}
                <div class="inline-left-title-main-right">
                  {{ infoList.hopeEntrytime }}
                </div>
              </div>

              <div class="inline-left-title-main">{{ $t("workLocation") }}
                <el-tooltip placement="top" :content="infoList.workPlace"> 
                <div class="inline-left-title-main-right">
                  {{ infoList.workPlace }}
                </div>
              </el-tooltip> 
              </div>

              <div class="inline-left-title-main">{{ $t("occupation") }}
                <el-tooltip placement="top" :content="infoList.profession"> 
                <div class="inline-left-title-main-right">
                  {{ infoList.profession }}
                </div>
              </el-tooltip> 
              </div>
            </div>
          </div>

          <!-- 第五行 -->
          <div class="inline-log-box">
            <div class="long-box-title">{{ $t("selfPR") }}</div>
            <!-- <el-tooltip placement="top" :content="infoList.pr">  -->
            <div class="long-box-main">
              {{ infoList.pr }} </div>
            <!-- </el-tooltip>  -->
          </div>
        </div>
      </div>
      <!--    分页部分-->
      <div class="pagination">
        <div class="pagination-main">
          <el-pagination @current-change="handleCurrentChange" :current-page="currentPage" layout=" prev, pager, next"
            :total="totalNum" :page-size="pageSize">
          </el-pagination>
          <!-- Rows per page -->
          <div class="rowsPage">
            <span>Rows per page</span>
            <div class="rowsPage-css">
              <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link">
                  {{ pageSize }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a">7</el-dropdown-item>
                  <el-dropdown-item command="b">15</el-dropdown-item>
                  <el-dropdown-item command="c">20</el-dropdown-item>
                  <el-dropdown-item command="d">25</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>

        </div>
      </div>

    </div>
  </div>
</template>

<script>
import axios from "axios";
import { allPersonnelQuery, updateResumeStatus, stateChangesInfoAdmin, getUrlFromOSS, } from "../../js/api";
import { fuzzyPersonnelQuery } from "../../js/api";
import AES from "../../js/AES";
export default {
  name: "adminTalentManagement",
  components: {},
  data() {
    return {
      tableData: [],//结果集
      dialogIsShow: false,
      dialogIsShow1: false,
      infoList: [],
      label1: true,
      label2: true,
      label3: true,
      label4: true,
      labelListHandle: [],
      form: {
        region: ""
      },
      stateChange: [], //更改状态
      multipleSelection: [],
      searchData1: "", //表格第一个搜索
      searchData2: "", //表格第二个搜索
      searchData3: "", //表格第三个搜索
      searchData4: "", //表格第四个搜索
      searchData5: "", //表格第五个搜索
      searchData6: "", //表格第六个搜索
      searchData7: "",
      searchData8: "",
      searchData9: "",
      searchData10: "",
      searchData11: "",
      searchData12: "",
      searchData13: "",
      searchData14: "",
      searchData15: "",
      searchData16: "",
      searchData17: "",
      searchData18: "",
      searchData19: "",
      searchData20: "",
      searchData21: "",
      searchData22: "",
      searchData23: "",
      searchData24: "",
      searchData25: "",
      searchData26: "",
      searchData27: "",
      searchData28: "",
      searchData29: "",
      searchData30: "",
      searchData31: "",
      searchData32: "",
      searchData33: "",
      searchData34: "",
      searchData35: "",
      searchData36: "",
      dropdownData1: "", //第一个下拉
      currentPage: 1, //页数
      pageSize: 7, //每页条数
      loading: false, //table loading
      searchDataStart: "",
      statusData: [],
      totalNum: 0,
      urlImgInfo: "",
      resumeStatusChange: "",
      language: "",
      applicationStatus: "",
      applicationStatusName: "All",
      applicationStatusCode: "",
      applicationStatusData: [],
      english: "",
      englishName: "All",
      englishCode: "",
      englishData: [],
      japanese: "",
      japaneseName: "All",
      japaneseCode: "",
      japaneseData: [],
      sex: "",
      sexName: "All",
      sexCode: "",
      sexData: [],
    };
  },

  created() {
    //获取当前语言的值
    this.language = window.localStorage.getItem('language')
    console.log("语言选择为" + window.localStorage.getItem('language'))
    console.log("页面语言选择为" + this.language)
    this.getLanguage();

    this.getList()
    this.getReviewStatus();
    this.getapplicationStatus()
    this.getenglish();
    this.getjapanese();
    this.getsex();
  },
  destroyed() {
    window.removeEventListener('setItemEvent', this.languageChange, true)
  },
  mounted() {
    window.addEventListener('setItemEvent', this.languageChange, true)
  },
  computed: {
    elInputSearch() {
      return this.$t("ifRegisteredEnterName");
    }, //搜索部分的placeholder
  },
  methods: {
    replaceText(data){
       return data.split(' ')[0]
    },
    //监听语言
    languageChange(e) {
      const that = this;
      console.log("------监听数据------")
      console.log(e)
      if (e.key && e.key == "language" && e.newValue) {
        that.language = e.newValue
        this.getList()
        this.getReviewStatus();
        this.getapplicationStatus()
        this.getenglish();
        this.getjapanese();
        this.getsex();
      }
    },

    //点击人才跳转至平台管理员人才修改
    jump(resumeId) {
      console.log("跳转")
      console.log("管理id" + resumeId)
      this.$router.push({
        path: '/educationalInstitutionTalentRevisionProgress1',
        name: 'educationalInstitutionTalentRevisionProgress1',
        params: { resumeId: resumeId }
      });

    },
    //获取状态数据字典
    getReviewStatus() {
      var that = this;
      that.getLanguage();
      axios.get('/api/modules-parent/common/getDateItem',
        {
          params: {
            dataItem: that.resumeStatusChange
          },
          headers: {
            'content-type': 'application/x-www-form-urlencoded',
            "token": localStorage.getItem("token")
          }
        })
        .then(function (res) {
          if (res.data.code === "A0000" || res.data.code === "C0252") {
            console.log("--------获取数据字典接口数据review_status--------");
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));

            that.statusData = aesFecInfo.data;

            console.log("--------获当然是看获取的状态了--------");

            console.log(that.statusData);
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    //管理者变更人才状态接口
    handleUpdateAppStatus(evt) {
      const that =this;
      const params = new URLSearchParams();
      params.append('resumeId', this.multipleSelection[0]);
      params.append('status', evt.code);
      axios
        .post("/api/modules-parent/personnelQuery/updateResumeStatus", params, {
          headers: {
            //头部参数
            'Content-Type': 'application/x-www-form-urlencoded',
            'token': localStorage.getItem("token")
          }
        })
        .then( (res)=> {
          console.log(res)
         this.$message({
            message: this.language === "CN" ? '修改成功!' : '修正に成功する!',
            type: 'success'
          });
          that.getList();
          //请求成功
        })
        .catch(function (error) {
          //请求失败
          console.log(error);
        });
      // updateResumeStatus(adminUpdateJobStatusDTO).then((res)=>{
      //   console.log("--------管理者变更简历状态接口数据--------");
      //   console.log(res);
      //   if (res.data.code === "A0000") {
      //     // this.$router.go(0)
      //     const aesFecInfo = JSON.parse(AES.decrypt(res.data.data))
      //     console.log("解密后信息"+AES.decrypt(res.data.data))
      //     console.log(aesFecInfo)
      //     this.$message({
      //       message: '修改成功!',
      //       type: 'success'
      //     });
      //   }
      // }).catch((res)=>{
      //   console.log("管理者变更应聘状态接口异常:",res)
      // })



    },
    //模糊查询
    fuzzyQuery() {
      var personnelDTO = {
        resumeId: this.searchData1,
        name: this.searchData2,
        anonym: this.searchData3,
        principal: this.searchData4,
        educationName: this.searchData5,
        address: this.searchData6,
        telephone: this.searchData7,
        email: this.searchData8,
        qualification1: this.searchData9,
        qualification2: this.searchData10,
        qualification3: this.searchData11,
        pr: this.searchData12,
        school: this.searchData13,
        profession: this.searchData14,
        enrollment: this.searchData15,
        graduation: this.searchData16,
        workPlace: this.searchData17,
        type: this.searchData18,
        startYear: this.searchData19,
        endYear: this.searchData20,
        hopeWorkplace: this.searchData21,
        hopeForm1: this.searchData22,
        hopeForm2: this.searchData23,
        hopeForm3: this.searchData24,
        hopeForm4: this.searchData25,
        hopeSalary: this.searchData26,
        startSalary: this.searchData27,
        endSalary: this.searchData28,
        otherHope: this.searchData29,
        //createTime:this.searchData30,
        //updateTime:this.searchData31,
        visitedTime: this.searchData32
      }
      console.log(personnelDTO);
      fuzzyPersonnelQuery(personnelDTO).then((res) => {
        console.log(res);
        if (res.data.code === "A0000") {
          const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
          this.tableData = aesFecInfo.data;
          this.totalNum = aesFecInfo.total
        } else {
          this.$message.error(res.data.message);
        }
      }).catch((res) => { });
    },
    //table排序
    changeTableSort(column) {
      console.log(column);
      if (column.prop === "minimum") {
        if (column.order === "ascending") {
          this.tableData = this.tableData.sort(
            (a, b) => a["minimum"] - b["minimum"]
          );
        } else {
          this.tableData = this.tableData.sort(
            (a, b) => b["minimum"] - a["minimum"]
          );
        }
      } else if (column.prop === "maximumAmount") {
        if (column.order === "ascending") {
          this.tableData = this.tableData.sort(
            (a, b) => a["maximumAmount"] - b["maximumAmount"]
          );
        } else {
          this.tableData = this.tableData.sort(
            (a, b) => b["maximumAmount"] - a["maximumAmount"]
          );
        }
      } else if (column.prop === "pageView") {
        if (column.order === "ascending") {
          this.tableData = this.tableData.sort(
            (a, b) => a["pageView"] - b["pageView"]
          );
        } else {
          this.tableData = this.tableData.sort(
            (a, b) => b["pageView"] - a["pageView"]
          );
        }
      }
    },
    handleCurrentChange(evt) {
      this.currentPage = evt;
      this.getList();
    },

    //每页条数下拉框
    handleCommand(command) {
      if (command === "a") {
        this.pageSize = 7;
        console.log(7);
      } else if (command === "b") {
        this.pageSize = 15;
        console.log(15);
      } else if (command === "c") {
        this.pageSize = 20;
        console.log(20);
      } else if (command === "d") {
        this.pageSize = 25;
        console.log(25);
      }
      this.currentPage = 1;
      this.getList();
    },
    handleSelectionChange(val) {
      this.multipleSelection = [];
      for (var i = 0; i < val.length; i++) {
        this.multipleSelection.push(val[i].resumeId);
      }
      this.stateChange = val;
    },
    getList() {
      var dto = {
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
      };
      allPersonnelQuery(dto).then((res) => {
        console.log(res);
        if (res.data.code === "A0000") {
          const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
          this.tableData = aesFecInfo.data;
          this.totalNum = aesFecInfo.total
          console.log("列表信息");
          console.log(this.tableData);
          console.log(this.totalNum);


        } else {
          this.$message.error(res.data.message);
        }
      }).catch((res) => { });
    },
    //状态变更
    handleAlterClick() {
      if (this.stateChange.length === 1) {
        this.dialogIsShow = true;
      } else if (this.stateChange.length > 1) {
        this.$message({
          message: $t('OnlyOneMessageSelected'),
          type: "warning"
        });
      } else if (this.stateChange.length < 1) {
        this.$message({
          message: this.$t('selectLeastOneMessage'),
          type: "warning"
        });
      }
    },

    handleSaveClick(resumeId) {
      this.$router.push({
        path: '/educationalInstitutionTalentRevisionProgress1',
        name: 'educationalInstitutionTalentRevisionProgress1',
        params: { resumeId: resumeId }
      });
    },
    handleClick(evt) {
      if (evt === "0") {
        //男生所需逻辑
        console.log("男");
      } else {
        //女生所需逻辑
        console.log("女");
      }
    },
    //删除
    handleDeleteClick() {
      const that =this;
      if (that.stateChange.length < 1) {
        that.$message({
          message: that.$t('selectLeastOneMessage'),
          type: "warning"
        });
      } else {
        const fakeInfo = {
          listId: that.multipleSelection
        };
        var data = {
          listId: that.multipleSelection
        }
        axios({
          method: "delete",
          url: "/api/modules-parent/personnelQuery/personnelBatchDelete",
          data: data,
          headers: {
            "token": localStorage.getItem("token")
          }
        }).then(res => {
          if (res.data.code === "A0000") {
            // this.handleAddClick();
            that.$message({
              message: that.$t('successfullyDeleted'),
              type: 'success'
            });
            that.getList();
          } else {
            that.$message.error(res.data.message);
          }
          console.log(res.data);
        });
      }
    },
    //buttton
    dialogFormVisible() { },
    stateSure() { },
    stateList() { },
    //新增跳转
    handleAddClick() {
      this.$router.push({
        path: '/adminTalentAdd1',
      });
    },
    //行点击
    rowClick(row) {
      console.log(row)
      console.log("行点击事件")

      this.dialogIsShow1 = "true";
      this.getinfoList(row);//普通数据渲染
      this.getUrl(row.avatar);//获取图片
      this.getLable(row);//获取高亮

    },
    //获取高亮
    getLable(row) {
      if (row.label1 === "1") {
        this.labelIsShow(1);
      } else {
        this.labelDel(1);
      }
      if (row.label2 === "1") {
        this.labelIsShow(2);
      } else {
        this.labelDel(2);
      }
      if (row.label2 === "1") {
        this.labelIsShow(2);
      } else {
        this.labelDel(2);
      }
      if (row.label3 === "1") {
        this.labelIsShow(3);
      } else {
        this.labelDel(3);
      }
      if (row.label4 === "1") {
        this.labelIsShow(4);
      } else {
        this.labelDel(4);
      }
    },
    //获取infoList
    getinfoList(row) {
      this.infoList.name = row.name;
      this.infoList.sex = row.sex;
      this.infoList.address = row.address;
      this.infoList.email = row.email;
      this.infoList.birth = row.birth;
      this.infoList.telephone = row.telephone;
      this.infoList.enrollment = row.enrollment;
      this.infoList.graduation = row.graduation;
      this.infoList.school = row.school;
      this.infoList.profession = row.profession;
      this.infoList.japanese = row.japanese;
      this.infoList.english = row.english;
      this.infoList.other = row.other;
      this.infoList.startYear = row.startYear;
      this.infoList.endYear = row.endYear;
      this.infoList.workPlace = row.workPlace;
      this.infoList.profession = row.profession;
      this.infoList.hopeEntrytime = row.hopeEntrytime;
      this.infoList.type = row.type;
      this.infoList.qualification1 = row.qualification1;
      this.infoList.qualification2 = row.qualification2;
      this.infoList.qualification3 = row.qualification3;
      this.infoList.pr = row.pr;
      this.infoList.educationName = row.educationName;//

    },
    // 头像回显
    getUrl(avatar) {
      var fakeInfo = {
        message: avatar
      }
      getUrlFromOSS(fakeInfo).then((res) => {
        console.log("-----------头像回显-----------")
        if (res.data.code === '200 OK') {
          const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
          console.log(aesFecInfo)
          this.urlImgInfo = aesFecInfo.message
        }
        console.log(res)
      }).catch((res) => {
        console.log("-----------头像回显-----------")
        console.log(res)
      })
    },
    //标签删除方法
    labelDel(num) {
      if (num === 1) {
        for (var i = 0; i < this.labelListHandle.length; i++) {
          if (this.labelListHandle[i] === "外国人歓迎") {
            this.labelListHandle.splice(i, 1);
            this.label1 = true;
            console.log("关闭 外国人歓迎 标签")
          }
        }
      } else if (num === 2) {
        for (var i = 0; i < this.labelListHandle.length; i++) {
          if (this.labelListHandle[i] === "未経験 OK") {
            this.labelListHandle.splice(i, 1);
            this.label2 = true;
            console.log("关闭 未経験 OK 标签")
          }
        }
      } else if (num === 3) {
        for (var i = 0; i < this.labelListHandle.length; i++) {
          if (this.labelListHandle[i] === "新卒 OK") {
            this.labelListHandle.splice(i, 1);
            this.label3 = true;
            console.log("关闭 新卒 OK 标签")
          }
        }
      } else if (num === 4) {
        for (var i = 0; i < this.labelListHandle.length; i++) {
          if (this.labelListHandle[i] === "学歴問わない") {
            this.labelListHandle.splice(i, 1);
            this.label4 = true;
            console.log("关闭 学歴問わない 标签")
          }
        }
      }
      console.log(this.labelListHandle)
    },
    //   标签高亮显示
    labelIsShow(num) {
      if (num === 1) {
        this.label1 = false;
        this.labelListLength(1);
      } else if (num === 2) {
        this.label2 = false;
        this.labelListLength(2);
      } else if (num === 3) {
        this.label3 = false;
        this.labelListLength(3);
      } else if (num === 4) {
        this.label4 = false;
        this.labelListLength(4);
      }
    },
    //判断labelListHandle长度 并且去重方法
    labelListLength(num) {
      if (this.labelListHandle.length < 4) {
        if (num === 1) {
          if (this.labelListHandle.indexOf("外国人歓迎") === -1) {
            this.labelListAdd(1);
          } else {
            return;
          }
        } else if (num === 2) {
          if (this.labelListHandle.indexOf("未経験 OK") === -1) {
            this.labelListAdd(2);
          } else {
            return;
          }
        } else if (num === 3) {
          if (this.labelListHandle.indexOf("新卒 OK") === -1) {
            this.labelListAdd(3);
          } else {
            return;
          }
        } else if (num === 4) {
          if (this.labelListHandle.indexOf("学歴問わない") === -1) {
            this.labelListAdd(4);
          } else {
            return;
          }
        } else {
          return;
        }
      }
    },
    //labelListHandle  push 方法
    labelListAdd(num) {
      if (num === 1) {
        this.labelListHandle.push("外国人歓迎");
      } else if (num === 2) {
        this.labelListHandle.push("未経験 OK");
      } else if (num === 3) {
        this.labelListHandle.push("新卒 OK");
      } else if (num === 4) {
        this.labelListHandle.push("学歴問わない");
      } else {
        return;
      }
      console.log(this.labelListHandle);
    },
    dialogClose1() {
      this.dialogIsShow1 = false;
    },
    //获得语言
    getLanguage() {
      if (this.language === "CN") {
        this.resumeStatusChange = "resumeStatusChange"
        this.applicationStatus = "applicationStatus"
        this.english = "english"
        this.japanese = "japanese"
        this.sex = "sex"
      }
      else {
        this.resumeStatusChange = "jpresumeStatusChange"
        this.applicationStatus = "jpapplicationStatus"
        this.english = "jpenglish"
        this.japanese = "jpjapanese"
        this.sex = "jpsex"
      }
    },
    //获取applicationStatus下拉
    handleCommandapplicationStatus(evt) {
      this.applicationStatusCode = evt.code;
      this.applicationStatusName = evt.name;
    },
    //获取english下拉
    handleCommandenglish(evt) {
      this.englishCode = evt.code;
      this.englishName = evt.name;
    },
    //获取japanese下拉
    handleCommandjapanese(evt) {
      this.japaneseCode = evt.code;
      this.japaneseName = evt.name;
    },
    //获取sex下拉
    handleCommandsex(evt) {
      this.sexCode = evt.code;
      this.sexName = evt.name;
    },

    getsex() {
      var that = this;
      that.getLanguage();
      axios.get('/api/modules-parent/common/getDateItem',
        {
          params: {
            dataItem: that.sex
          },
          headers: {
            'content-type': 'application/x-www-form-urlencoded',
            "token": localStorage.getItem("token")
          }
        })
        .then(function (res) {
          if (res.data.code === "A0000" || res.data.code === "C0252") {
            console.log("--------获取数据字典接口数据sex--------");
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.sexData = aesFecInfo.data;
            console.log("--------获当然是看获取的状态了--------");
            console.log(that.sexData);
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },

    getjapanese() {
      var that = this;
      that.getLanguage();
      axios.get('/api/modules-parent/common/getDateItem',
        {
          params: {
            dataItem: that.japanese
          },
          headers: {
            'content-type': 'application/x-www-form-urlencoded',
            "token": localStorage.getItem("token")
          }
        })
        .then(function (res) {
          if (res.data.code === "A0000" || res.data.code === "C0252") {
            console.log("--------获取数据字典接口数据japanese--------");
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.japaneseData = aesFecInfo.data;
            console.log("--------获当然是看获取的状态了--------");
            console.log(that.japaneseData);
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },

    getenglish() {
      var that = this;
      that.getLanguage();
      axios.get('/api/modules-parent/common/getDateItem',
        {
          params: {
            dataItem: that.english
          },
          headers: {
            'content-type': 'application/x-www-form-urlencoded',
            "token": localStorage.getItem("token")
          }
        })
        .then(function (res) {
          if (res.data.code === "A0000" || res.data.code === "C0252") {
            console.log("--------获取数据字典接口数据english--------");
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.englishData = aesFecInfo.data;
            console.log("--------获当然是看获取的状态了--------");
            console.log(that.englishData);
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },

    getapplicationStatus() {
      var that = this;
      that.getLanguage();
      axios.get('/api/modules-parent/common/getDateItem',
        {
          params: {
            dataItem: that.applicationStatus
          },
          headers: {
            'content-type': 'application/x-www-form-urlencoded',
            "token": localStorage.getItem("token")
          }
        })
        .then(function (res) {
          if (res.data.code === "A0000" || res.data.code === "C0252") {
            console.log("--------获取数据字典接口数据applicationStatus--------");
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.applicationStatusData = aesFecInfo.data;
            console.log("--------获当然是看获取的状态了--------");
            console.log(that.applicationStatusData);
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },


  },
};
</script>

<style scoped>
.main-css {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
}

.main-box {
  /*表格*/
  margin-top: 0px;
  width: 100%;
  padding: 0 40px 0 80px;
  box-sizing: border-box;
  height: calc(100% - 136px);
}

.title-css {
  /*标题样式*/
  font-family: "lucida sans unicode", "lucida grande", sans-serif;
  /*字体*/
  color: #686868;
  /*字体颜色*/
  font-size: 2em;
  /*字体大小*/
  text-align: center;
  /*对齐方式*/
  line-height: 76px;
  /*行间距*/
  margin-top: 10px;
}

.line-button-box {
  height: 40px;
  width: 100%;
  display: flex;
  margin-top: 25px;
  margin-left: 40px;
}

.button-css {
  width: 90px;
  height: 35px;
  background: #51abff;
  box-sizing: border-box;
  border-radius: 4px;
  font-weight: 500;
  font-size: 12px;
  color: #fff;
  margin-right: 25px;
  text-align: center;
}

.search {
  width: 100%;
  height: 25px;
  display: flex;
}

.search /deep/ .el-input__inner {
  width: 314px;
  height: 24px;
}

.search /deep/ .el-input {
  width: 314px;
  height: 24px;
  line-height: 24px;
  box-sizing: border-box;
}

.search /deep/ .el-input__icon {
  line-height: 24px;
}

.search button {
  width: 85px;
  height: 24px;
  line-height: 24px;
  background: #fafafa;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  color: #51abff;
  cursor: pointer;
  margin-left: 20px;
}

.table {
  width: 100%;
  margin-top: 10px;
  height: auto;
  overflow-y: auto;
  /* max-height: 87%; */
}

.table /deep/ .el-input__inner {
  border: 1px solid transparent;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #c9cfda;
  padding: 0;
  text-align: center;
}

.operate {
  height: 51px;
}

.table /deep/ .el-dropdown {
  width: 60px;
}

.table-img-css {
  border-radius: 50%;
}

.el-dropdown-link {
  /*下拉框*/
  cursor: pointer;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #00072b;
  width: 100%;
  display: inline-block;
}

.table /deep/ .el-icon-arrow-down {
  float: right;
  height: 20px;
  line-height: 20px;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.table /deep/ .el-table__cell {
  position: relative;
  text-align: center;
}

.table /deep/ .caret-wrapper {
  display: inline-block;
  position: absolute;
  top: -4px;
  right: -48px;
  width: 67px;
}

.save-button {
  width: 69px;
  height: 36px;
  background: #fff;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 10px;
  color: #51abff;
  cursor: pointer;
  margin-right: 10px;
}

.pagination {
  /*分页*/
  width: 95%;
  height: 50px;
  margin-top: 10px;
}

.pagination-main {
  /*分页*/
  float: right;
  margin-right: 10px;
  display: flex;
}

.rowsPage {
  /*RowsPage*/
  height: 30px;
  line-height: 30px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #454d59;
  display: flex;
  margin-left: 10px;
}

.rowsPage-css {
  width: 60px;
  height: 26px;
  line-height: 26px;
  background: #ffffff;
  border: 1px solid #b0bac9;
  box-sizing: border-box;
  padding: 0 5px 0 10px;
  margin-left: 12px;
}

.rowsPage /deep/ .el-dropdown-link {
  width: 45px;
  height: 26px;
  line-height: 26px;
}

.rowsPage /deep/ .el-icon-arrow-down {
  float: right;
  line-height: 26px;
}

.employee-application {
  background: rgba(0, 0, 0, 0.2);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9;
  display: flex;
  justify-content: center;
  align-items: center;
}

.dialog-box {
  height: 800px;
  width: 618px;
  padding: 0 40px;
  padding: 20px 0;
  box-sizing: border-box;
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  position: relative;
  overflow-x: hidden;
}

.close-button {
  width: 50px;
  text-align: center;
  line-height: 50px;
  height: 50px;
  position: absolute;
  top: 0;
  right: 0;
  font-weight: 700;
  font-size: 20px;
  color: #686868;
  cursor: pointer;
}

.case-img {
  border: 1px;
  width: 100%;
  height: 114px;
  display: flex;
  justify-content: space-between;
}

.one-box-left1 {
  width: 200px;
  height: 70%;
  padding-left: 80px;
  padding-top: 15px;
  box-sizing: border-box;
  display: flex;
  justify-content: left;
  border-radius: 50%
}

.one-box-left2 {
  padding-left: 40px;
  width: 600px;
  height: 100px;
  background: #FFFFFF;
  border-radius: 4px;
  margin: auto;
}

.one-box-left-line1 {
  width: 80%;
  height: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.one-box-left-line2 {
  width: 80%;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.one-box-left-line3 {
  width: 80%;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.one-box-left-line4 {
  width: 80%;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.one-box-left-line-smallleft {
  width: 30%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  /* or 171% */
  display: flex;
  align-items: center;
  /* 灰色字体 */
  color: #686868;

}

.one-box-left-line-smallright {
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  /* or 143% */

  display: flex;
  align-items: center;

  /* 灰色字体 */

  color: #686868;
}

.label {
  width: 100%;
  height: 26px;
  margin-top: 0px;
  margin-left: 50px;
}

.label-box {
  padding: 0 5px;
  background: #b2b2b2;
  border-radius: 4px;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #ffffff;
  float: left;
  margin-right: 20px;
}

.label-box span {
  display: inline-block;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #fff;
  line-height: 14px;
  color: #b2b2b2;
  text-align: center;
  margin-left: 10px;
  cursor: pointer;
}

.label-box-active span {
  height: 13px;
  width: 13px;
  background: #fff;
  border-radius: 50%;
  line-height: 13px;
  text-align: center;
  margin-left: 10px;
  display: inline-block;
  color: #b2b2b2;
}

.label-box-active {
  float: left;
  height: 24px;
  padding: 0 5px;
  line-height: 24px;
  background: #51abff;
  border-radius: 4px;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
  overflow: hidden;
  margin-right: 20px;
}

.inline-box {
  height: 60px;
  width: 100%;
  margin-top: 10px;
  margin-left: 60px;
}

.inline-left {
  width: 200px;
  height: 180px;
  margin-right: 45px;
  float: left;
  /*background: #51abff;*/
}

.inline-right {
  width: 240px;
  height: 180px;
  margin-right: 45px;
  float: left;
}

.inline-left-title {
  width: 100%;
  height: 25px;
  line-height: 30px;
  font-weight: 700;
  font-size: 14px;
  color: #686868;
  border-bottom: 1px solid #686868;
  /*background:yellow;*/
}

.inline-left-title-main {
  width: 240px;
  height: 32px;
  line-height: 50px;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #686868;
  /*background: peru;*/
}

.inline-left-title-main-right {
  width: 82%;
  height: 32px;
  line-height: 50px;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #686868;
  float: right;
  width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

}

.inline-log-box {
  margin-top: 10px;
  width: 100%;
  height: 120px;
}

.inline-log-box {
  margin-top: 10px;
  width: 100%;
  height: 80px;
  margin-left: 60px;
}

.long-box-title {
  height: 40px;
  line-height: 30px;
  width: 485px;
  font-weight: 700;
  font-size: 14px;
  color: #686868;
  border-bottom: 1px solid #686868;
}

.long-box-main {
  width: 485px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #686868;
  padding-bottom: 30px;
  display: -webkit-box;
  /* -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden; */
}
</style>



// WEBPACK FOOTER //
// src/pages/adminTalentManagement/index.vue